export default function PageHero({ kicker, title, subtitle, image }) {
  return (
    <section className="relative overflow-hidden">
      <div className="relative h-[280px] md:h-[360px]">
        {image && <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-br from-brand to-slate-900/90" style={image ? { mixBlendMode: "multiply" } : {}} />
        <div className="absolute inset-0 hero-overlay" />
        <div className="container-page relative z-10 h-full flex flex-col justify-center text-white">
          {kicker && <div className="text-xs font-bold uppercase tracking-widest text-accent mb-3">{kicker}</div>}
          <h1 className="font-montserrat font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-3xl">{title}</h1>
          {subtitle && <p className="mt-3 text-white/85 max-w-2xl text-base md:text-lg">{subtitle}</p>}
        </div>
      </div>
    </section>
  );
}
